import CluppTextArea from "../../../Components/CluppForms/CluppTextArea";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const DescribeClupp = ({ state, setState, field }) => {
  const validateTextArea = (value) => {
    const words = value.trim().split(/\s+/).length;
    
    return new Promise((resolve) => {
      setTimeout(() => {
        if (words < 2) {
          resolve({
            haveAnError: true,
            errorMessage: "Al menos debes escribir 2 atributos de Clupp",
          });
        } else {
          resolve({
            haveAnError: false,
            errorMessage: "",
          });
        }
      }, 500); // Retraso de 500 ms antes de actualizar el estado de error
    });
  };
  return (
    <>
      <TitleHeaders
        title={"¿Qué es Clupp para ti en al menos 2 palabras?"}
        subtitle={""}
        isRequired={true}
      />
      <CluppTextArea
      state={state}
        label={"Reseña"}
        multiline={true}
        setState={setState}
        field={field}
        variant="filled"
        autoFocus={true}
        validationFunction={validateTextArea}
      />
    </>
  );
};

export default DescribeClupp;
